import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../pages/context/AuthContext";


export default function CustomerRoute({ children }) {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (Number(user.role) !== 7) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
